'use strict';

angular.module('ClinicApp').controller('ModalProviderOfferedServicesCtrl', function($scope, $modalInstance, $q, provider, modelType, ProviderService) {
  $scope.provider = provider;

  if (modelType == 'clinic') {
    $scope.modalTitle = 'Services Offered @ ' + provider.clinic.name;
  } else if (modelType == 'doctor') {
    $scope.modalTitle = 'Services Offered by ' + provider.doctor.name;
  } else {
    throw new Error('ModalArgumentError: `ModalProviderOfferedAppointmentTypesCtrl` invalid modelType value: ' + modelType);
  }

  var offeredServicesByService = _.indexBy($scope.provider.offeredServices, function(os) {
    return os.service.id;
  });

  $scope.serviceColumns = _.chain($scope.provider.doctor.potentialServices).cloneDeep()
    .map(function(service) {
      service.selected = !!offeredServicesByService[service.id];
      return service;
    })
    .sortByOrder(['name'], ['asc'])
    .chunk(Math.round($scope.provider.doctor.potentialServices.length / 2))
    .value();

  $scope.save = function() {
    var promises = [];
    _.each(_.flatten($scope.serviceColumns), function(service) {
      if (service.selected && !offeredServicesByService[service.id]) {
        promises.push(ProviderService.addOfferedService($scope.provider.id, service.id));
      }
      if (!service.selected && offeredServicesByService[service.id]) {
        promises.push(
          ProviderService.removeOfferedService($scope.provider.id, offeredServicesByService[service.id].id),
        );
      }
    });
    return $q.all(promises).then(function() {
      $modalInstance.close();
    });
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };

});
